/**
 * VehicleWheel3D property formatter. It substitutes Godot's defaults (types.ts),
 * so the panel shows the effective value Godot would simulate. `engine_force`,
 * `brake` and `steering` are runtime inputs, shown only when set, so a static
 * preview does not imply a vehicle is accelerating.
 */
import { formatNode3DProperties } from '../../../base/node3d/propertyFormatter';
import { VEHICLE_WHEEL_3D_DEFAULTS as DEFAULTS } from './types';
export function formatVehicleWheel3DProperties(properties) {
    const num = (value, fallback) => String(value ?? fallback);
    const drive = [
        { label: 'Traction', value: String(properties.use_as_traction ?? DEFAULTS.use_as_traction) },
        { label: 'Steering', value: String(properties.use_as_steering ?? DEFAULTS.use_as_steering) },
    ];
    if (properties.engine_force !== undefined) {
        drive.push({ label: 'Engine Force', value: String(properties.engine_force) });
    }
    if (properties.brake !== undefined) {
        drive.push({ label: 'Brake', value: String(properties.brake) });
    }
    if (properties.steering !== undefined) {
        drive.push({ label: 'Steering Angle', value: String(properties.steering) });
    }
    const sections = [
        {
            title: 'Wheel',
            items: [
                { label: 'Radius', value: num(properties.wheel_radius, DEFAULTS.wheel_radius) },
                { label: 'Rest Length', value: num(properties.wheel_rest_length, DEFAULTS.wheel_rest_length) },
                { label: 'Friction Slip', value: num(properties.wheel_friction_slip, DEFAULTS.wheel_friction_slip) },
                {
                    label: 'Roll Influence',
                    value: num(properties.wheel_roll_influence, DEFAULTS.wheel_roll_influence),
                },
            ],
        },
        {
            title: 'Suspension',
            items: [
                { label: 'Stiffness', value: num(properties.suspension_stiffness, DEFAULTS.suspension_stiffness) },
                { label: 'Travel', value: num(properties.suspension_travel, DEFAULTS.suspension_travel) },
                { label: 'Max Force', value: num(properties.suspension_max_force, DEFAULTS.suspension_max_force) },
                {
                    label: 'Damping Compression',
                    value: num(properties.damping_compression, DEFAULTS.damping_compression),
                },
                {
                    label: 'Damping Relaxation',
                    value: num(properties.damping_relaxation, DEFAULTS.damping_relaxation),
                },
            ],
        },
        { title: 'Drive', items: drive },
    ];
    sections.push(...formatNode3DProperties(properties));
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map